import { BACKEND_URL } from './constants';

/* eslint-disable no-undef */
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || BACKEND_URL;
